export default function validationMoisComptable(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf("Error converting value {null} to type 'System.Guid'. Path 'exerciceComptableId'") === 0) {
      messages.push({ message: 'addEditMoisComptable.validation.exerciceComptable' });
    }
    if (message.indexOf('MOIS_COMPTABLE_CHEVAUCHEMENT') === 0) {
      messages.push({ message: 'addEditMoisComptable.validation.moisComptableChevauchement' });
    }
  });
}
